module.exports = __webpack_public_path__ + "img/avatar.52d73f99.png";